export const SERVICE_TYPE = {
  NEW_BORN: "Newborn Care Specialist",
  SITTER: "Sitter",
  NANNY: "Nanny",
  PRIVATE_EDUCATOR: "Private Educator"
};



// WEBPACK FOOTER //
// ./src/constants/employer.js